<template>
  <div class="error-content">
    <img :src="src" class="error">
    <span>{{text}}</span>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      default: '该内容不存在',
      type: String
    },
    src: {
      type: String,
      default: 'https://s.kcimg.cn/app/quick/images/no-content.png'
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang = 'less' scoped>
.error-content {
    width: 100%;
    height: 100%;
    text-align: center;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 100;
    background: #f3f4f5;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .error {
    margin: 0 auto;
    width: 180px;
    height: 140px;
    margin-bottom: 28px;
  }

  .error-content span {
    font-size: 15px;
    color:rgba(3,16,42,0.6);
    display: block;
  }
</style>
